import { lazyRemoteModule } from '@space-shell/lib/runtime'

import type { SendDatahubModerationClickFAQClubParams } from './types'

const useSendDataHubModeration = () => {
  const sendDatahubModerationClickFAQClub = async ({
    membershipSlug,
    membershipId,
    ucode,
    userId,
    hasAccess
  }: SendDatahubModerationClickFAQClubParams) => {
    const remoteHook = await lazyRemoteModule<
      () => {
        sendDatahubModerationClickFAQClub: (args: object) => void
      }
    >('ModerationSupport/useSendDataHubModeration')

    const sendDatahubModerationClickFAQClub = remoteHook?.().sendDatahubModerationClickFAQClub

    sendDatahubModerationClickFAQClub?.({
      membershipSlug,
      membershipId,
      ucode,
      userId,
      hasAccess
    })
  }

  return { sendDatahubModerationClickFAQClub }
}

export default useSendDataHubModeration
